import React, { memo } from 'react';
import { Paper, Shimmer, ShimmerPlaceholderText } from '../../../../../ui';

export const PaymentMainUserShimmer = memo(() => (
	<Paper data-testid="payment-main-user-shimmer">
		<Shimmer>
			<ShimmerPlaceholderText width="40%" height="1.75em" />
			<hr />
			<p>
				<ShimmerPlaceholderText />
				<ShimmerPlaceholderText width="70%" />
			</p>
		</Shimmer>
	</Paper>
));
